import { render } from "./MediaLoader.vue?vue&type=template&id=b4e34748&scoped=true"
import script from "./MediaLoader.vue?vue&type=script&lang=js"
export * from "./MediaLoader.vue?vue&type=script&lang=js"

import "./MediaLoader.vue?vue&type=style&index=0&id=b4e34748&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/dating-app/dating-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e34748"]])

export default __exports__